"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDiscountUserCodeToJSON = exports.OrderDiscountUserCodeFromJSONTyped = exports.OrderDiscountUserCodeFromJSON = void 0;
function OrderDiscountUserCodeFromJSON(json) {
    return OrderDiscountUserCodeFromJSONTyped(json, false);
}
exports.OrderDiscountUserCodeFromJSON = OrderDiscountUserCodeFromJSON;
function OrderDiscountUserCodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': json['_id'],
        'orderDiscount': json['orderDiscount'],
        'user': json['user'],
        'codes': json['codes'],
    };
}
exports.OrderDiscountUserCodeFromJSONTyped = OrderDiscountUserCodeFromJSONTyped;
function OrderDiscountUserCodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'orderDiscount': value.orderDiscount,
        'user': value.user,
        'codes': value.codes,
    };
}
exports.OrderDiscountUserCodeToJSON = OrderDiscountUserCodeToJSON;
